<template>
  <div
    :class="['tris-scroll-good-billion', type === 'scroll' ? 'scroll' : '']"
    @click="goDetail"
  >
    <good-image
      :img-url="ssu.skuImg.imgUrl"
      :image-width="goodWidth"
      :stock-status="stockStatus"
      :left-upper-tag="leftUpperTag"
      :billion-tip="leftBottomTag"
      :sku-img="skuImg"
      :custom-style="customImagStyle"
    />
    <div class="tris-scroll-info">
      <base-info
        single-name
        :custom-style="baseInfoStyle"
        :name="ssu.skuBase.skuName"
      />
      <good-price-billion
        total-price-placeholder
        :ssu="ssu"
        :ssu-info="ssuInfo"
        :custom-style="customPriceStyle"
        :custom-operator="customOperator"
        @goDetail="goDetail"
      />
    </div>
  </div>
</template>

<script>
import mixin from '../newMixin'
// import {
//   THEME_START_COLOR,
//   THEME_ENG_COLOR,
//   THEME_COLOR
// } from '@/defines/environment/config'

export default {
  name: 'NewTrisScrollGoodBillon',
  mixins: [mixin],
  data() {
    return {
      baseInfoStyle: {
        name: {
          fontSize: '0.24rem',
          'text-overflow': 'ellipsis',
          overflow: 'hidden',
          'white-space': 'nowrap'
        },
        format: {
          fontSize: '0.22rem'
        }
      },
      customImagStyle: {
        width: '1.20rem',
        height: '1.20rem'
      }
    }
  },
  computed: {
    customPriceStyle() {
      return {
        billionPrice: {
          fontSize: this.type === 'scroll' ? '0.28rem' : '0.3rem'
        }
      }
    },
    customOperator() {
      return {
        simple: false,
        showPromoteTip: false,
        type: 'large',
        btnWith: this.type === 'scroll' ? 1.6 : 1.92,
        canScroll: this.type === 'scroll',
        bgStartColor: '#FF790B',
        bgEndColor: '#FF4636',
        iconColor: '#FF4635'
      }
    }
  }
}
</script>

<style lang="scss">
.tris-scroll-good-billion {
  overflow: hidden;

  background-color: #fff;
  border-radius: 0.16rem;

  flex: none;
  box-sizing: border-box;
  @include flex(column, flex-start, flex-start, nowrap);
  .tris-scroll-info {
    position: relative;

    width: 100%;
    box-sizing: border-box;

    padding: 0.08rem 0.08rem 0.12rem 0.08rem;

    overflow: hidden;

    flex: auto;
  }
}
</style>
